import { deleteFormRequest, stopFormRequest, logicDeleteFormRequest } from '@/api/project/form'
import dayjs from 'dayjs'
import { getHasButtonAuth } from '@/utils/auth'
import { pick } from 'lodash'
import { removeHtmlTag } from '@/utils'

export default {
  props: [],
  data() {
    return {
      editablePageTypes: ['editor', 'logic', 'theme', 'setting', 'publish'],
      folderId: 0,
      projectStatusList: [
        { code: '', name: '全部', color: '#006EFF', detailPage: '' },
        { code: 1, name: '待发布', color: '#909399', detailPage: 'editor' },
        { code: 2, name: '收集中', color: '#409EFF', detailPage: 'data' },
        { code: 3, name: '已停止', color: '#F56C6C', detailPage: 'data' }
      ],
      projectTypeList: [
        { code: '', name: '全部', color: '#006EFF' },
        { code: 1, name: '表单', color: '#5190DE' },
        { code: 2, name: '流程', color: '#FF770F' },
        { code: 4, name: '考试', color: '#59C075' }
      ],
      projectDialogTitle: {
        create: '创建表单',
        edit: '编辑表单',
        copy: '复制表单'
      }
    }
  },
  filters: {
    formatDate(time) {
      return dayjs(time).format('YYYY/MM/DD')
    }
  },
  computed: {},
  methods: {
    canEditProject(form) {
      return form?.canEdit !== false
    },
    canShowProjectPermission(form) {
      return this.canEditProject(form) && (form?.isOwner || getHasButtonAuth(['project_collaboration']))
    },
    isEditablePage(type) {
      return this.editablePageTypes.includes(type)
    },
    getType(key) {
      const item = this.projectTypeList.find((e) => e.code === key)
      return item || { name: '', color: '' }
    },
    getProjectStatus(key) {
      const item = this.projectStatusList.find((e) => e.code === key)
      return item || { name: '', color: '', detailPage: '' }
    },
    logicDeleteForm(key) {
      logicDeleteFormRequest({ formKey: key }).then((res) => {
        if (res.data) {
          this.msgSuccess('刪除成功')
          this.$emit('refresh')
          this.clearCache()
        }
      })
    },
    deleteForm(key) {
      deleteFormRequest({ formKey: key }).then((res) => {
        if (res.data) {
          this.msgSuccess('刪除成功')
          this.$emit('refresh')
        }
      })
    },
    stopProject(key) {
      stopFormRequest({ formKey: key }).then((res) => {
        if (res.data) {
          this.msgSuccess('停止成功')
          this.$emit('refresh')
        }
      })
    },
    toProjectHandle(form, type) {
      let _type = type
      if (this.isEditablePage(type) && !this.canEditProject(form)) {
        _type = 'data'
      }
      if (!getHasButtonAuth([_type])) {
        let narData = JSON.parse(this.$store.getters['user/navTree'])
        const filterNavData = this.filterRoutes(narData)
        const hasAuthPage = filterNavData.findIndex((item, idx) => {
          const itemType = item.path.split('/form/')[1]
          _type = itemType
          return getHasButtonAuth([itemType])
        })
        if (hasAuthPage === -1) {
          this.msgWarning('抱歉，您的账号没有权限，请联系管理员')
          return
        }
      }
      if (this.isEditablePage(_type) && !this.canEditProject(form)) {
        _type = 'data'
      }

      this.$store.dispatch('form/setFormTitle', removeHtmlTag(form.name))
      this.$router.push({
        path: `/form/${_type}`,
        query: { key: form.formKey, active: type, type: form.type, status: form.status }
      })
    },
    clearCache() {
      const PATH = process.env.VUE_APP_API_ROOT + '/workOrderLogic/querySimpleFormNameMap'
      let respone = this.$store.getters['cache/getCacheByPath'](`${PATH}>respone`)
      respone && this.$store.commit('cache/clearCache', `${PATH}>respone`)
    },
    /**
     *
     * 路由数据格式转
     */
    filterRoutes(routes) {
      let res =
        routes
          .filter((route) => route.name == '我的项目')[0]
          .children?.map((childRouter) => {
            //只保留需要的数据
            let bkroute = pick(childRouter, ['id', 'icon', 'name', 'path', 'mate'])
            return bkroute
          }) || []
      return res
    }
  }
}
